import { render, staticRenderFns } from "./SourceCockpit.vue?vue&type=template&id=2ea831ec&scoped=true"
import script from "./SourceCockpit.vue?vue&type=script&lang=js"
export * from "./SourceCockpit.vue?vue&type=script&lang=js"
import style0 from "./SourceCockpit.vue?vue&type=style&index=0&id=2ea831ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea831ec",
  null
  
)

export default component.exports